export var Labels = {
    paymentOptionDivider: 'หรือ',
    cardHolderName: 'ชื่อและนามสกุลที่ปรากฎอยู่บนบัตร',
    cardNumber: 'หมายเลขบัตร',
    cardExpiration: 'วันหมดอายุบัตร MM/YY',
    cvv: 'หมายเลข CVV',
    continueButton: 'ตรวจทานและดำเนินการต่อ'
};
export var FieldErrors = {
    invalidCardHolderName: 'กรุณาใส่ชื่อและนามสกุลที่ปรากฎอยู่บนบัตร.',
    invalidCreditCardNumber: 'กรุณาใส่หมายเลขบัตรที่ถูกต้อง.',
    invalidCardBrand: 'Please enter a supported card brand.',
    invalidExpirationDate: 'กรุณาใส่วันหมดอายุบัตรที่ถูกต้อง.',
    invalidCvv: 'กรุณาใส่หมายเลข CVV ที่ถูกต้อง.'
};
